import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, Switch, Route } from 'react-router-dom'
import { DatePicker, Menu, Dropdown } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'

import { stringifyDate, useListData, useToggle, usePet, useShift } from '../../modules'

import Receive from '../../components/reusable/receive'
import Patient from '../../components/reusable/patient'

import NewPatient from '../../components/drawers/newPatient'
import BillPatient from '../../components/drawers/billPatient'
import PatientDetails from '../../components/drawers/patient'
import { rangePresets } from '../../data'

const { RangePicker } = DatePicker

const Patients = () => {
    const [ranges, setRanges] = useState()
    const [chosen, setChosen] = useState([])
    const [ptnt, setPatient] = useState()
    const [string, setString] = useState('')
    const [category, setCategory] = useState('')
    const [billingCandidate, setBillingCandidate] = useState()
    const [pendingBillingVisitCheck, setPendingBillingVisitCheck] = useState(false)
    
    const [newpatient, toggleNewPatient] = useToggle()
    const [select, toggleSelect] = useToggle()
    const [billPt, toggleBillPatient] = useToggle()

    const { shift } = useSelector(state => state.application)

    const [Shifts, ShiftsModal] = useShift('Pharmacy')

    const [
        { loading: pLoading, error: pError, fetch: fetchPatients },
        { list: patients },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('patients', ranges ? { string, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { string }, { notify: true })

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const refresh = () => {
        navigate(1)
        fetchPatients()
    }

    const search = str => {
        setString(str)
        refresh()
    }

    const selectRange = range => {
        setRanges(range)
        refresh()
    }

    const openBillDrawer = pt => {
        setPatient(pt)
        setTimeout(toggleBillPatient, 100)
    }

    const [, fetchBillingVisit] = usePet('patientActiveVisit', { patient: billingCandidate?._id }, {
        notify: true,
        manual: true,
        callback: ({ data: visit }, notif, ops) => {
            if (!visit) {
                notif('This patient has no active outpatient visit. Complete triage check-in before billing pharmacy items.', ops('warning'))
                setBillingCandidate(null)
                return
            }

            openBillDrawer(billingCandidate)
            setBillingCandidate(null)
        }
    })

    useEffect(() => {
        if (!pendingBillingVisitCheck || !billingCandidate?._id) return

        setPendingBillingVisitCheck(false)
        fetchBillingVisit()
    }, [pendingBillingVisitCheck, billingCandidate?._id]) // eslint-disable-line react-hooks/exhaustive-deps

    const billPatient = pt => {
        setBillingCandidate(pt)
        setPendingBillingVisitCheck(true)
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                {
                    ptnt &&
                    <BillPatient
                        fixCategory
                        patient={ ptnt }
                        category="Pharmacy"
                        categories={['Pharmacy']}
                        onClose={ () => {
                            setCategory()
                            // refresh()
                            setPatient()
                        } }
                        toggle={ toggleBillPatient }
                        visible={ billPt } />
                }
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={ rangePresets }/>
                    <Dropdown
                        overlay={
                            <Menu>
                                <Menu.Item onClick={() => null}>Patient Visits</Menu.Item>
                            </Menu>
                        }>
                        <button className="btn hisani-btn-green-light ml-2 text-white">
                            <span className="hidden xs:block mr-2">Reports</span>
                            <AiOutlineDown />
                        </button>
                    </Dropdown>
                    <Shifts />
                </div>
                { ShiftsModal }
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Patients</h2>
                    <span className="flex items-center justify-between">
                        {/* {
                            shift &&
                            <Link to="/app/pharmacy/patients/new">
                                <button className="btn ml-2 hisani-btn-green-light text-white">
                                    <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                    <span className="hidden xs:block ml-2">New Patient</span>
                                </button>
                            </Link>
                        } */}
                        <button onClick={refresh} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        loading={pLoading}
                        error={pError}>
                        {
                            patients?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient Name</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Added On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Latest Visit</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                patients.map((patient, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select ?
                                                                        <input
                                                                            onChange={() => choose(patient._id)}
                                                                            checked={chosen.includes(patient._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={ patient } />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(patient.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        {
                                                                            shift &&
                                                                            <Link to={ `/app/pharmacy/patients/${patient._id}` }><Menu.Item>Details</Menu.Item></Link>
                                                                        }
                                                                        <Menu.Item onClick={() => billPatient(patient)}>Bill to Pharmacy</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">You can add a new patient by clicking above</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
                <Switch>
                    <Route path="/app/pharmacy/patients/new">
                        <NewPatient
                            path="/app/pharmacy/patients"
                            onPerform={ refresh } />
                    </Route>
                    <Route path="/app/pharmacy/patients/:id">
                        <PatientDetails 
                            reload={ refresh } 
                            source="/app/pharmacy/patients" />
                    </Route>
                </Switch>
            </div>
        </div>       
    )
}

export default Patients
